import { paths } from 'src/routes/paths';
import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

//Modificar de acuerdo a la lógica de la acción
export const darDeBajaClienteF = createAsyncThunk(
  'clienteForm/darDeBajaClienteF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.darDeBajaClienteF,
        data
      );
      handleOKRequest(response, 'El cliente pasó a estado "Baja".');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al dar de baja el cliente.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const darDeAltaClienteF = createAsyncThunk(
  'clienteForm/darDeAltaClienteF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.darDeAltaClienteF,
        data
      );
      handleOKRequest(response, 'El cliente pasó a estado "Alta".');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al dar de alta el cliente.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const verificarClienteF = createAsyncThunk(
  'clienteForm/verificarClienteF',
  async (
    { data, formRef }: { data: any; formRef: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(
        endpoints.actions.verificarClienteF,
        data
      );
      formRef.current.instance.updateData({ id: response.data });
      handleOKRequest(response, 'El cliente pasó a estado "Verificado".');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al verificar el cliente.'
      );
    }
  }
);
